<div [id]="konvaContainerName" ></div>
